import { call, put } from 'redux-saga/effects';
import BookAppointmentTimeslotActions from '../redux/BookAppointmentTimeslotRedux';
import { api } from './api';


export function* bookappointmenttimeslotsagas(action: any): Generator<any, void, any> {
  const { childId, categoryId, timeslotId } = action;
  const response = yield call(api.bookAppointmentTimeslot, childId, categoryId, timeslotId);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(BookAppointmentTimeslotActions.bookAppointmentTimeslotSuccess(response.data));
  } else {
    yield put(BookAppointmentTimeslotActions.bookAppointmentTimeslotFailure(response.status));
  }
}